import React from "react";
import Question from "../Global/Question";

const Industries = (props) => {
  return <Question {...props} />;
};

export default Industries;
